<template>
  <article>
    <section class="xbed-sub-title">
      <span>入账单列表</span>
    </section>
    <section class="xbed-breadcrumb">
      <Breadcrumb>
        <BreadcrumbItem>订单管理</BreadcrumbItem>
        <BreadcrumbItem>入账单列表</BreadcrumbItem>
      </Breadcrumb>
    </section>
    <Form class="add-distance" :model="formItem" inline>
      <Row>
        <formItem label="创建时间" :label-width="80">
          <datePicker v-model="createStartDate" type="daterange" placement="bottom-end" placeholder="" class="dataStyle">
          </datePicker>
        </formItem>
        <formItem label="房费日期" :label-width="80">
          <datePicker v-model="curStartDate" type="daterange" placement="bottom-end" placeholder="" class="dataStyle">
          </datePicker>
        </formItem>
        <formItem label="订单号" :label-width="80">
          <Input v-model="orderNumber" :maxlength="30" placeholder=""></Input>
        </formItem>
        <formItem label="房间id" :label-width="80">
          <Input v-model="roomId" :maxlength="30" placeholder=""></Input>
        </formItem>
        <formItem label="门店" :label-width="60">
          <Select v-model="selectChain" clearable filterable placeholder="id/名称 输入下拉选择" style="width:220px">
            <Option v-for="(item, index) in chainList" :key="index" :value="item.chainId">{{
              `${item.chainId}_${item.chainName}` }}</Option>
          </Select>
        </formItem>
        <formItem label="预定渠道" :label-width="80">
          <Select v-model="reservationWay.value" class="publicStyle">
            <Option value="first">全部</Option>
            <Option v-for="item in reservationWay.optionList" :value="item.id" :key="item.id">{{ item.name }}</Option>
          </Select>
        </formItem>
        <formItem label="入账单类型" :label-width="83">
          <Select v-model="yzOwener.paySource" multiple class="publicStyle" style="width:300px;">
            <!-- <Option value="9">全部</Option> -->
            <Option value="1">新单房费</Option>
            <Option value="2">换房房费</Option>
            <Option value="3">续住房费</Option>
            <Option value="18">换房差价</Option>
            <Option value="8">押金</Option>
          </Select>
        </formItem>
        <formItem label="日结状态" :label-width="83">
          <Select v-model="yzOwener.stat" class="publicStyle">
            <Option value="0">全部</Option>
            <Option value="1">待完成</Option>
            <Option value="2">已完成</Option>
            <Option value="3">已取消</Option>
          </Select>
        </formItem>
        <formItem label="房间号" :label-width="80">
          <Input v-model="yzOwener.no" :maxlength="100" placeholder=""></Input>
        </formItem>
        <formItem label="对账状态" :label-width="80">
          <Select v-model="yzOwener.reconciliationState" class="publicStyle">
            <Option value="-1">全部</Option>
            <Option value="0">未结算</Option>
            <Option value="1">已结算</Option>
          </Select>
        </formItem>
        <formItem label="结算账期" :label-width="80">
          <Select v-model="yzOwener.settleAccount" class="publicStyle">
            <Option value="-1">全部</Option>
            <Option v-for="item in setDate" :key='item.id' :value="item.settleDate">{{ item.settleDate }}</Option>
          </Select>
        </formItem>
        <formItem label="业主姓名" :label-width="80">
          <Input v-model="yzOwener.name" :maxlength="100" placeholder=""></Input>
        </formItem>
        <formItem label="业主手机" :label-width="80">
          <Input v-model="yzOwener.phone" :maxlength="11" placeholder=""></Input>
        </formItem>
        <formItem>
          <Button type="primary" @click="queryByJudgeItem">查询</Button>
          <Button type="primary" @click="exportByJudgeItem" :loading="exportBtn" style="margin-left: 8px">导出</Button>
        </formItem>
      </Row>
    </Form>
    <Table stripe :columns="billColumns" :data="handleList" :loading="consumloading"></Table>
    <Page class="add-distance" :total="table.datacount" :class-name="tablePage" :current="table.page" show-sizer
      show-total :page-size="table.pageSize" @on-page-size-change="handelPageSize" @on-change="handelPage"></Page>
    <Modal v-model="successModal" title="注意：确定取消入账单？该操作不可恢复,请谨慎操作" ref="cancelModal" :loading="true" @on-ok="remove()"
      @on-cancel="cancel">
      <Form :rules='cancelRules' ref="cancelForm">
        <FormItem label="备注：" prop="textNote">
          <Input v-model="textNote" :autosize="{ minRows: 5, maxRows: 6 }" type="textarea" placeholder="请输入..."></Input>
        </FormItem>
      </Form>
    </Modal>
  </article>
</template>

<script>
import Moment from "moment";
import Utils from "@/utils";
import Config from "@/config";
import API from "@/api";
export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.userid = Utils.findFromLocalStorage("vue-userid");
    this.env = Utils.findFromLocalStorage("env", "dev");
  },
  async mounted() {
    this.$Notice.config({
      top: 200
    }),
      this.queryConsumptionsByDate();
    this.getPowers();
    this.orderSourceListAll();
    this.querySettleAccountDateList()
    this.getChainList()
  },
  data() {
    const validateTypeList = {
      textNote: (rule, value, callback) => {
        if (!this.textNote) {
          callback(new Error('取消原因必填'))
        } else {
          callback();
        }
      }
    }
    return {
      consumloading: false,
      setDate: [],//结算周期
      exportBtn: false,
      //表格绑定数据
      table: {
        datacount: 0,
        page: 1,
        pageSize: 10,
      },
      tablePage: 'table-page',
      //初始化创建时间和房费时间日期
      createStartDate: [Moment().subtract(60, 'days').format('YYYY-MM-DD'),
      Moment().format('YYYY-MM-DD')],
      curStartDate: [Moment().subtract(60, 'days').format('YYYY-MM-DD'),
      Moment().add(60, 'days').format('YYYY-MM-DD')],
      handleList: [],
      cannelRow: {},
      formItem: {},
      cancelJudgeItem: false,
      // queryJudgeItem: false,
      exportJudgeItem: false,
      // RetCode:1,
      successModal: false,
      failModal: false,
      yzOwener: {
        phone: '',
        name: '',
        no: '',
        paySource: [],
        stat: '0',
        reconciliationState: '-1',
        settleAccount: '-1'
      },
      consumptionList: [],
      orderNumber: '',
      roomId: '',
      reservationWay: {
        value: 'first',
        optionList: []
      },
      stateSelect: '',
      cancelRules: {
        textNote: [
          { required: true, validator: validateTypeList.textNote, trigger: 'blur' }
        ],
      },
      textNote: '',
      chainList: [], // 门店列表
      selectChain: '', // 已选择的门店id
      billColumns: [
        {
          title: '创建时间',
          key: 'createdAt',
          width: 200,
          align: 'center'
        },
        {
          title: '订单号',
          key: 'orderNo',
          width: 220,
          align: 'center'
        },
        {
          title: '类型',
          key: 'paySource',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let paySource = ''
            let color = 'default'
            let style = {
              visibility: 'visible'
            }

            switch (params.row.paySource) {
              case 1:
                paySource = '新单房费'
                color = 'green'
                break;
              case 2:
                paySource = '换房房费'
                color = 'green'
                break;
              case 3:
                paySource = '续住房费'
                color = 'green'
                break;
              case 8:
                paySource = '押金'
                color = 'red'
                break;
              case 4:
                paySource = 'OMS补录优惠';
                break;
              case 5:
                paySource = '线下小住优惠';
                break;
              case 6:
                paySource = '取消订单退款';
                break;
              case 7:
                paySource = '提前退房退款';
                break;
              case 9:
                paySource = 'OTA渠道差价';
                break;
              case 10:
                paySource = '重复扣款';
                break;
              case 11:
                paySource = '公司免费房提供';
                break;
              case 12:
                paySource = '开发部协议免费房';
                break;
              case 13:
                paySource = '长留优惠';
                break;
              case 18:
                paySource = '换房差价';
                break;
              default:
                style = {
                  visibility: 'hidden'
                }
                break;
            }
            return h('Tag', {
              props: {
                color
              },
              style
            }, paySource);
          }
        },
        {
          title: '子入住单号',
          key: 'checkinInfoId',
          width: 120,
          align: 'center'
        },
        {
          title: '预订渠道',
          key: 'orderSourceName',
          width: 100,
          align: 'center'
        },
        {
          title: '支付单号',
          key: 'payNo',
          width: 200,
          align: 'center'
        },
        {
          title: '支付状态',
          key: 'payStat',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let payStat = ''
            let props = {}
            let style = {
              visibility: 'visible'
            }
            if (params.row.paySource != 8) {// 非押金
              switch (params.row.payStat) {
                // 账务表中的新建
                case 1:
                  payStat = '未支付'
                  props = { style: { color: 'default' } }
                  break;
                // 账务表中的已支付
                case 2:
                  payStat = '已支付'
                  props = { color: 'green' }
                  break;
                // 账务表中的已退款
                case 3:
                  payStat = '已支付'
                  props = { color: 'red' }
                  break;
                default:
                  style = {
                    visibility: 'hidden'
                  }
                  break;
              }
            } else {// 押金
              switch (params.row.payStat) {
                // 押金表中的新建
                case 0:
                  payStat = '未支付'
                  props = { style: { color: 'red' } }
                  break;
                // 押金表中的已支付
                case 1:
                  payStat = '已支付'
                  props = { color: 'green' }
                  break;
                default:
                  style = {
                    visibility: 'hidden'
                  }
                  break;
              }
            }
            return h('Tag', { props, style }, payStat);
          }
        },
        {
          title: '结算账期',
          key: 'settleDate',
          width: 100,
          align: 'center',
          render: (h, params) => {
            const date = params.row.settleDate ? params.row.settleDate : '-'
            return h('div', {}, date)
          }
        },
        {
          title: '房间id',
          key: 'roomId',
          width: 100,
          align: 'center'
        },
        {
          title: '房间号',
          key: 'roomNo',
          width: 150,
          align: 'center'
        },
        {
          title: '房费日期',
          key: 'curDate',
          width: 130,
          align: 'center'
        },
        {
          title: '日结状态',
          key: 'stat',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let stat = ''
            let props = {}
            let style = {
              visibility: 'visible'
            }
            if (params.row.paySource != 8) {// 非押金
              switch (params.row.stat) {
                case 1:
                  stat = '待完成'
                  props = { color: 'default' }
                  break;
                case 2:
                  stat = '已完成'
                  props = { color: 'green' }
                  break;
                case 3:
                  stat = '已取消'
                  props = { color: 'red' }
                  break;
                default:
                  style = {
                    visibility: 'hidden'
                  }
                  break;
              }
            } else {// 押金
              switch (params.row.stat) {
                case 1:
                  stat = '有效'
                  props = { color: 'default' }
                  break;
                case 2:
                  stat = '无效'
                  props = { color: 'green' }
                  break;
                case 3:
                  stat = '待退款'
                  props = { color: 'red' }
                  break;
                case 4:
                  stat = '已退款'
                  props = { color: 'red' }
                  break;
                default:
                  style = {
                    visibility: 'hidden'
                  }
                  break;
              }
            }
            return h('Tag', { props, style }, stat);
          }
        },
        {
          title: '业主',
          key: 'ownerNameAndPhone',
          width: 200,
          align: 'center'
        },
        {
          title: '原价',
          key: 'price',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let price = (params.row.price % 100) > 0 ? (params.row.price / 100).toFixed(2) : (params.row.price / 100)
            return h('div', price)
          }
        },
        {
          title: '业主优惠',
          key: 'yzDiscount',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let yzDiscount = (params.row.yzDiscount % 100) > 0 ? (params.row.yzDiscount / 100).toFixed(2) : (params.row.yzDiscount / 100)
            return h('div', yzDiscount)
          }
        },
        {
          title: 'xbed优惠',
          key: 'xbDiscount',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let xbDiscount = (params.row.xbDiscount % 100) > 0 ? (params.row.xbDiscount / 100).toFixed(2) : (params.row.xbDiscount / 100)
            return h('div', xbDiscount)
          }
        },
        {
          title: '房费应付',
          key: 'realPrice',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let realPrice = (params.row.realPrice % 100) > 0 ? (params.row.realPrice / 100).toFixed(2) : (params.row.realPrice / 100)
            return h('div', realPrice)
          }
        },
        {
          title: 'OTA佣金',
          key: 'channelCommission',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let channelCommission = (params.row.channelCommission % 100) > 0 ? (params.row.channelCommission / 100).toFixed(2) : (params.row.channelCommission / 100)
            return h('div', channelCommission)
          }
        },
        {
          title: '渠道活动费',
          key: 'otherChannelExpenses',
          width: 110,
          align: 'center',
          render: (h, param) => {
            return h('span', (param.row.otherChannelExpenses / 100).toFixed(2))
          }
        },
        {
          title: '业主推广费',
          key: 'yzPromotionExpense',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let yzPromotionExpense = (params.row.yzPromotionExpense % 100) > 0 ? (params.row.yzPromotionExpense / 100).toFixed(2) : (params.row.yzPromotionExpense / 100)
            return h('div', yzPromotionExpense)
          }
        },
        {
          title: 'xbed推广费',
          key: 'xbPromotionExpense',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let xbPromotionExpense = (params.row.xbPromotionExpense % 100) > 0 ? (params.row.xbPromotionExpense / 100).toFixed(2) : (params.row.xbPromotionExpense / 100)
            return h('div', xbPromotionExpense)
          }
        },
        {
          title: 'xdollar',
          key: 'xdollar',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let xdollar = (params.row.xdollar % 100) > 0 ? (params.row.xdollar / 100).toFixed(2) : (params.row.xdollar / 100)
            return h('div', xdollar)
          }
        },
        {
          title: '卡券',
          key: 'cardRealPrice',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let cardRealPrice = params.row.cardRealPrice > 0 ? (params.row.cardRealPrice / 100).toFixed(2) : (params.row.cardRealPrice / 100)
            return h('div', cardRealPrice)
          }
        },
        {
          title: 'xbed实收',
          key: 'receivedPrice',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let receivedPrice = (params.row.receivedPrice % 100) > 0 ? (params.row.receivedPrice / 100).toFixed(2) : (params.row.receivedPrice / 100)
            return h('div', receivedPrice)
          }
        },
        {
          title: '结算房费',
          key: 'settlementPrice',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let settlementPrice = (params.row.settlementPrice % 100) > 0 ? (params.row.settlementPrice / 100).toFixed(2) : (params.row.settlementPrice / 100)
            return h('div', settlementPrice)
          }
        },
        {
          title: '平台服务费',
          key: 'platformPrice',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let platformPrice = (params.row.platformPrice % 100) > 0 ? (params.row.platformPrice / 100).toFixed(2) : (params.row.platformPrice / 100)
            return h('div', platformPrice)
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 100,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'error',
                  size: 'small'
                },
                style: {
                  display: (params.row.stat == 1 && params.row.payStat != 1 && params.row.paySource != 8) ? 'block' : 'none'
                },
                on: {
                  click: () => {
                    this.cancelConsumptionButton(params.row);
                  }
                }
              }, '取消入账单')
            ]);
          }
        }
      ]
    }
  },
  methods: {
    // 结账月份列表
    async querySettleAccountDateList() {
      let params = {}
      let resp = (await API.omsAPI[this.env].order.settleAccountDateList(params, this.token)).data;
      if (resp.retCode) {
        this.$Notice.error({
          title: '获取结账月份数据异常',
          desc: resp.msg
        })
        return
      }
      this.setDate = resp
    },
    error(nodesc) {
      this.$Notice.error({
        title: '警告！！！',
        desc: nodesc ? '' : '你当前没有权限操作'
      });
    },
    success(nodesc) {
      this.$Notice.success({
        title: '提示！！',
        desc: nodesc ? '' : '操作成功'
      });
    },
    //取消入帐单按钮
    cancelConsumptionButton(row) {
      this.cannelRow = row;
      if (this.cancelJudgeItem) {
        this.successModal = true;
      } else {
        this.error(false);
      }
    },
    //模态框确定操作
    remove() {
      let validResult = false;
      this.$refs.cancelForm.validate(valid => {
        validResult = valid
      });
      if (!validResult) {
        this.$refs.cancelModal.buttonLoading = false;
        return;
      }
      this.cancelConsumption();
    },
    cancel() {
      this.$Message.info('Clicked cancel');
    },
    //分页的show sizer
    handelPageSize(pageSize) {
      this.table.pageSize = pageSize;
      this.table.page = 1;
      this.queryConsumptionsByDate();
    },
    handelPage(currentPage) {
      this.table.page = currentPage;
      this.queryConsumptionsByDate();
    },
    //表格数据请求getcheckInfo
    async queryConsumptionsByDate() {
      this.consumloading = true
      this.tablePage = 'table-page';
      let resp = (await API.omsAPI[this.env].php.queryConsumptionsByDate(
        {
          "createStartDate": (this.createStartDate[0] ? Moment(this.createStartDate[0]).format('YYYY-MM-DD') : ''),
          "createEndDate": (this.createStartDate[1] ? Moment(this.createStartDate[1]).format('YYYY-MM-DD') : ''),
          "curStartDate": (this.curStartDate[0] ? Moment(this.curStartDate[0]).format('YYYY-MM-DD') : ''),
          "curEndDate": (this.curStartDate[1] ? Moment(this.curStartDate[1]).format('YYYY-MM-DD') : ''),
          "page": this.table.page,
          "size": this.table.pageSize,
          "stat": (this.yzOwener.stat == 0 ? "" : this.yzOwener.stat),
          "orderNo": this.orderNumber,
          "roomId": this.roomId,
          "ownerPhone": this.yzOwener.phone,
          "ownerName": this.yzOwener.name,
          "paySourceIn": (this.yzOwener.paySource.toString()),
          "roomNo": this.yzOwener.no,
          "orderSource": (this.reservationWay.value === "first" ? "" : this.reservationWay.value),
          "settlementStatus": this.yzOwener.reconciliationState == '-1' ? '' : this.yzOwener.reconciliationState,
          "settleDate": this.yzOwener.settleAccount == '-1' ? '' : this.yzOwener.settleAccount,
          "chainId": this.selectChain
        }
      )).data;
      this.consumloading = false
      this.table.datacount = resp.total;
      this.handleList = resp.retdata.content;//table数据赋值
      // this.RetCode = resp.retcode;
      this.tablePage = '';
    },
    //取消入帐单‘确定’
    async cancelConsumption() {
      let res = (await API.omsAPI[this.env].php.cancelConsumption(
        { id: this.cannelRow.id, remark: this.textNote }
      )).data;
      if (res.retcode === 0) {
        this.successModal = false;
        this.textNote = '';
        this.queryConsumptionsByDate();
        this.success(false);
      } else {
        // this.error( false );
        this.$Notice.error({
          title: '警告！！！',
          desc: res.retmsg
        });
      }
    },
    //获取用户权限
    async getPowers() {
      let rest = (await API.omsAPI[this.env].php.getPowers(158)).data;
      this.cancelJudgeItem = rest.cancelConsumption;
      // this.queryJudgeItem = rest.consumptionList;
      this.exportJudgeItem = rest.exportConsumptionRecord;
    },
    //获取预定渠道列表
    async orderSourceListAll() {
      let respt = (await API.omsAPI[this.env].php.orderSourceListAll(158)).data;
      this.reservationWay.optionList = respt.retdata
    },
    //导出数据表
    exportConsumptionRecord() {
      let param = "createStartDate=" + (this.createStartDate[0] ? Moment(this.createStartDate[0]).format('YYYY-MM-DD') : '') +
        "&createEndDate=" + (this.createStartDate[1] ? Moment(this.createStartDate[1]).format('YYYY-MM-DD') : '') +
        "&curStartDate=" + (this.curStartDate[0] ? Moment(this.curStartDate[0]).format('YYYY-MM-DD') : '') +
        "&curEndDate=" + (this.curStartDate[1] ? Moment(this.curStartDate[1]).format('YYYY-MM-DD') : '') +
        "&page=" + this.table.page +
        "&size=" + this.table.pageSize +
        "&stat=" + (this.yzOwener.stat == 0 ? "" : this.yzOwener.stat) +
        "&orderNo=" + this.orderNumber +
        "&roomId=" + this.roomId +
        "&ownerPhone=" + this.yzOwener.phone +
        "&ownerName=" + this.yzOwener.name +
        "&paySourceIn=" + (this.yzOwener.paySource.toString()) +
        "&roomNo=" + this.yzOwener.no +
        "&orderSource=" + (this.reservationWay.value === "first" ? "" : this.reservationWay.value) +
        "&settlementStatus=" + (this.yzOwener.reconciliationState == '-1' ? '' : this.yzOwener.reconciliationState) +
        "&settleDate=" + (this.yzOwener.settleAccount == '-1' ? '' : this.yzOwener.settleAccount) +
        "&chainId=" + this.selectChain

      const exportUrl = `${Config[this.env].analysisUrl}excel/exportConsumptionRecord?${param}`
      Utils.exportExcelWeighting(exportUrl, this.token, this.$Notice.error, this, "exportBtn")
    },
    //查询
    queryByJudgeItem() {
      this.table.page = 1;
      this.queryConsumptionsByDate();

      // todo 去除查询接口权限
      // if(this.queryJudgeItem) {
      // 	this.table.page = 1;
      // 	this.queryConsumptionsByDate();
      // }else {
      // 	this.error(false);
      // }
    },
    exportByJudgeItem() {
      if (this.exportJudgeItem) {
        this.exportConsumptionRecord();
      } else {
        this.error(false);
      }
    },
    // 获取所有门店
    async getChainList() {
      const resp = (await API.omsAPI[this.env].cleaner.queryChainListForCleanOrder(this.token)).data;

      if (resp.retCode) {
        this.$Notice.error({
          title: "查询门店列表失败",
          desc: resp.msg
        });
        return
      }

      this.chainList = resp;
    },
  }
}
</script>

<style scoped>
.publicStyle {
  width: 200px;
}

.dataStyle {
  width: 200px;
}

.xbed-title {
  font-size: 2rem;
  margin-bottom: 0.6rem;
}

.subMenu {
  margin-bottom: 1.4rem;
}

.table-page {
  pointer-events: none;
}

.add-distance {
  margin-top: 20px;
}</style>



// WEBPACK FOOTER //
// src/pages/order/consumption-list.vue